import { css } from '@/styled-system/css';

// Floor plan image (inside p-1 wrapper)

export const floorPlanImageOuter = css({
  padding: '4px',
});

export const floorPlanImageWrapper = css({
  position: 'relative',
  width: '100%',
  height: '192px',
  borderRadius: '12px',
  overflow: 'hidden',
});

export const floorPlanImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
  borderRadius: '12px',
});

export const floorPlanImageButton = css({
  display: 'block',
  width: '100%',
  height: '100%',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
});

// No floor plan placeholder

export const noFloorPlanPlaceholder = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '192px',
  borderRadius: '12px',
  backgroundColor: '#f5f7f7',
  gap: '2x',
});

export const placeholderText = css({
  fontSize: 'tiny',
  fontWeight: '600',
  color: '#9eaead',
  letterSpacing: '0.3px',
});

export const placeholderSubtext = css({
  fontSize: '11px',
  fontWeight: '400',
  color: '#b8c6c5',
  letterSpacing: '0.2px',
});

// Floor plan summary line: "1 Bed · 1 bath · 750 sqft"

export const floorPlanSummary = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: '#212a3b',
  letterSpacing: '0.5px',
});

export const floorPlanSummarySeparator = css({
  fontWeight: '400',
  color: '#9e9e9e',
});

// Card content area

export const cardContent = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '2x',
  padding: '2x',
});

// Unit table

export const unitTable = css({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
  tableLayout: 'fixed',
});

export const unitTableHeader = css({
  fontWeight: '400',
  color: '#9e9e9e',
  fontSize: '12px',
  letterSpacing: '0.5px',
  lineHeight: '18px',
  textAlign: 'left',
  paddingX: '1x',
  paddingBottom: '1x',
});

export const unitTableHeaderAvailable = css({
  fontWeight: '400',
  color: '#9e9e9e',
  fontSize: '12px',
  letterSpacing: '0.5px',
  lineHeight: '18px',
  textAlign: 'right',
  paddingX: '1x',
  paddingBottom: '1x',
});

export const unitTableHeaderChevron = css({
  width: '28px',
  paddingBottom: '1x',
});

export const unitTableRow = css({
  cursor: 'pointer',
  outline: 'none',
  transitionProperty: 'background-color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _hover: {
    backgroundColor: '#f5f8f8',
    '& td:first-child': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& td:last-child': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  },
  _active: {
    backgroundColor: '#eef3f3',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
    '& td:first-child': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& td:last-child': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  },
});

// Cell with badge area (13px) + value — used for unit name and rent
export const cellWithBadgeArea = css({
  paddingTop: '5px',
  paddingBottom: '5px',
  paddingX: '1x',
  verticalAlign: 'bottom',
});

export const badgeArea = css({
  height: '13px',
  display: 'flex',
  alignItems: 'flex-end',
});

// Unit name cell
export const unitNameCell = css({
  paddingTop: '5px',
  paddingBottom: '5px',
  paddingX: '1x',
  verticalAlign: 'bottom',
});

export const unitNameCellContent = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  minWidth: 0,
});

export const unitNameText = css({
  fontSize: '16px',
  fontWeight: '700',
  color: 'hpxTeal500',
  letterSpacing: '0.3px',
  lineHeight: '22px',
  fontVariantNumeric: 'tabular-nums',
});

// NEW badge
export const unitNewBadgeWrapper = css({
  height: '13px',
  display: 'flex',
  alignItems: 'flex-end',
});

export const unitNewBadge = css({
  fontSize: '8px',
  fontWeight: '700',
  color: 'hpxTeal500',
  backgroundColor: '#e6f5f4',
  paddingX: '4px',
  paddingY: '1px',
  borderRadius: '2px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  lineHeight: '10px',
  whiteSpace: 'nowrap',
});

// Rent cell
export const rentCellContent = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const rentValue = css({
  display: 'flex',
  alignItems: 'center',
  lineHeight: '22px',
});

export const rentText = css({
  fontSize: '16px',
  fontWeight: '700',
  color: '#212a3b',
  letterSpacing: '0.3px',
});

export const priceDropOriginal = css({
  fontSize: '10px',
  fontWeight: '400',
  color: '#9e9e9e',
  textDecoration: 'line-through',
  letterSpacing: '0.2px',
  lineHeight: '10px',
});

export const priceDropArrow = css({
  fontFamily: 'system-ui, sans-serif',
  fontSize: '11px',
  fontWeight: '700',
  color: 'hpxTeal500',
  marginLeft: '3px',
  lineHeight: '1',
});

// Placeholder text for empty/unavailable fields (e.g., "Call")
export const placeholderValue = css({
  fontSize: '16px',
  fontWeight: '400',
  color: '#666666',
  letterSpacing: '0.3px',
  lineHeight: '22px',
});

// Available cell
export const availableCell = css({
  fontSize: '16px',
  fontWeight: '400',
  color: '#666666',
  letterSpacing: '0.3px',
  lineHeight: '22px',
  paddingBottom: '5px',
  paddingX: '1x',
  textAlign: 'right',
  verticalAlign: 'bottom',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

// Chevron cell
export const chevronCell = css({
  width: '28px',
  paddingBottom: '5px',
  verticalAlign: 'bottom',
  textAlign: 'center',
});

export const chevronChar = css({
  color: '#b0c4c2',
  fontSize: '20px',
  lineHeight: '20px',
  transitionProperty: 'color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  'tr:hover &': {
    color: 'hpxTeal500',
  },
});

// "See all X units →" link
export const seeAllLink = css({
  display: 'inline-block',
  marginTop: '3x',
  paddingX: '1x',
  paddingY: 'xs',
  textAlign: 'left',
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxTeal500',
  letterSpacing: '0.5px',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const seeAllArrow = css({
  fontFamily: 'system-ui, sans-serif',
  fontWeight: '700',
});

// Carousel item sizing

export const mobileCarouselItem = css({
  width: '100%',
  overflow: 'hidden',
});

export const desktopCarouselItem = css({
  width: '100%',
  minHeight: '420px',
  xxl: {
    width: 'calc(50% - 4px)',
  },
});

// Carousel containers

export const carouselContainer = css({
  display: 'block',
  marginTop: '2x',
  md: {
    display: 'none',
  },
});

export const desktopCarouselContainer = css({
  display: 'none',
  md: {
    display: 'block',
    marginTop: '2x',
  },
});

export const desktopCarouselRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  width: '100%',
});

export const desktopArrowColumn = css({
  flexShrink: 0,
  width: '36px',
});

export const desktopCardsArea = css({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'stretch',
});

export const desktopControlButton = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  borderWidth: '0.75px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  backgroundColor: 'hpxWhite',
  cursor: 'pointer',
  color: 'hpxBlue600',
  transitionProperty: 'background-color, color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _hover: {
    backgroundColor: 'hpxGrey100',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
  _disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
});

// Card styles

export const baseCard = css({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 !important',
});

export const compactCard = css({
  height: '100%',
  minHeight: '420px',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 !important',
});

export const compactImageWrapper = css({
  position: 'relative',
  width: '100%',
  height: '192px',
  borderRadius: '12px',
  overflow: 'hidden',
  flexShrink: 0,
});

export const compactUnitTableWrapper = css({
  flexGrow: 1,
  overflowY: 'auto',
  minHeight: 0,
});

export const bedroomTab = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: '25%',
});

export const dotContainer = css({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '2x',
  md: {
    display: 'none',
  },
});

// See All Units Modal/Overlay styles

export const modalBackdrop = css({
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 'zIndexOverlay',
});

export const modalContent = css({
  backgroundColor: 'hpxWhite',
  borderRadius: '12px',
  width: '90%',
  maxWidth: '900px',
  maxHeight: '80vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
});

export const modalHeader = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: '2x',
  paddingRight: '3x',
  paddingBottom: '2x',
  paddingLeft: '3x',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'hpxGrey400',
  flexShrink: 0,
});

export const modalTitle = css({
  fontSize: 'lg',
  fontWeight: '700',
  color: '#212a3b',
});

export const modalTitleDetail = css({
  fontSize: 'md',
  fontWeight: '600',
  color: '#6e6e6e',
});

export const modalCloseButton = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  color: 'hpxBlue600',
  flexShrink: 0,
  _hover: {
    backgroundColor: 'hpxGrey100',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const modalBody = css({
  display: 'flex',
  flexDirection: 'row',
  gap: '3x',
  padding: '3x',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const modalImageColumn = css({
  flexShrink: 0,
  width: '40%',
  maxWidth: '360px',
  alignSelf: 'flex-start',
});

export const modalTableColumn = css({
  flex: 1,
  minWidth: 0,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
});

// Custom sort dropdown

export const sortContainer = css({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '3x',
  paddingX: '1x',
});

export const sortTrigger = css({
  display: 'flex',
  alignItems: 'center',
  gap: '0',
  fontSize: 'sm',
  letterSpacing: '0.5px',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  paddingX: '1x',
  paddingY: '1x',
  borderRadius: '6px',
  transitionProperty: 'background-color',
  transitionDuration: '0.15s',
  _hover: {
    backgroundColor: '#f5f8f8',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const sortLabel = css({
  color: '#b0b8b7',
  fontWeight: '400',
});

export const sortValue = css({
  color: 'hpxGrey600',
  fontWeight: '400',
  marginLeft: '5px',
});

export const sortChevron = css({
  color: '#b0b8b7',
  marginLeft: '3px',
  flexShrink: 0,
});

export const sortDropdownPanel = css({
  position: 'absolute',
  left: 0,
  top: '100%',
  marginTop: 'xs',
  backgroundColor: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '12px',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
  zIndex: 'zIndexOverOverlay',
  width: '200px',
  overflow: 'hidden',
});

export const sortOption = css({
  width: '100%',
  textAlign: 'left',
  paddingX: '2x',
  paddingY: '10px',
  fontSize: 'sm',
  letterSpacing: '0.5px',
  border: 'none',
  cursor: 'pointer',
  backgroundColor: 'hpxWhite',
  color: 'hpxBlue500',
  _hover: {
    backgroundColor: '#f5f5f5',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
  _first: {
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
  },
  _last: {
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
});

export const sortOptionSelected = css({
  width: '100%',
  textAlign: 'left',
  paddingX: '2x',
  paddingY: '10px',
  fontSize: 'sm',
  fontWeight: '700',
  letterSpacing: '0.5px',
  border: 'none',
  cursor: 'pointer',
  backgroundColor: '#f0faf9',
  color: 'hpxTeal500',
  _hover: {
    backgroundColor: '#e6f5f4',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
  _first: {
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
  },
  _last: {
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
});

// Mobile bottom sheet

export const bottomSheetOverlay = css({
  position: 'fixed',
  inset: 0,
  zIndex: 'zIndexOverlay',
  display: 'flex',
  flexDirection: 'column',
});

export const bottomSheetBackdrop = css({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  pointerEvents: 'none',
});

export const bottomSheetPanel = css({
  marginTop: 'auto',
  backgroundColor: 'hpxWhite',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px',
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '90vh',
  animationName: 'slideUpFromBottom',
  animationDuration: '0.3s',
  animationTimingFunction: 'ease-out',
  animationFillMode: 'forwards',
});

export const bottomSheetPanelClosing = css({
  marginTop: 'auto',
  backgroundColor: 'hpxWhite',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px',
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '90vh',
  animationName: 'slideUpFromBottom',
  animationDuration: '0.25s',
  animationTimingFunction: 'ease-in',
  animationFillMode: 'forwards',
  animationDirection: 'reverse',
});

export const bottomSheetBackdropClosing = css({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  pointerEvents: 'none',
  opacity: 0,
  transitionProperty: 'opacity',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-in',
});

export const bottomSheetDragHandle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingY: '12px',
});

export const bottomSheetDragBar = css({
  width: '40px',
  height: '4px',
  backgroundColor: 'hpxGrey400',
  borderRadius: '9999px',
});

export const bottomSheetStickyHeader = css({
  flexShrink: 0,
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: 'hpxWhite',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px',
});

export const bottomSheetTitle = css({
  paddingX: '20px',
  paddingBottom: '2x',
});

export const bottomSheetTitleText = css({
  fontSize: '18px',
  fontWeight: '700',
  color: '#212a3b',
});

export const bottomSheetTitleDetail = css({
  fontSize: '15px',
  fontWeight: '600',
  color: 'hpxGrey600',
});

export const bottomSheetTitleSeparator = css({
  fontWeight: '400',
  color: 'hpxGrey600',
});

export const bottomSheetBody = css({
  flex: 1,
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  paddingBottom: '6x',
});

export const bottomSheetBodyInner = css({
  paddingX: '2x',
});

// Bordered image container for bottom sheet / modal
export const sheetImageBorder = css({
  borderRadius: '12px',
  overflow: 'hidden',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  marginBottom: '2x',
});

export const sheetImagePadding = css({
  padding: '4px',
});

export const bottomSheetImage = css({
  width: '100%',
  height: '192px',
  objectFit: 'contain',
  display: 'block',
  borderRadius: '12px',
});

export const sheetPlaceholderInner = css({
  width: '100%',
  height: '192px',
  borderRadius: '12px',
  backgroundColor: '#f8fafa',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2x',
});

export const sheetPlaceholderText = css({
  fontSize: 'tiny',
  fontWeight: '600',
  color: '#b0bcbb',
  letterSpacing: '0.3px',
});

export const sheetPlaceholderSubtext = css({
  fontSize: '11px',
  fontWeight: '400',
  color: '#c8d2d1',
  letterSpacing: '0.2px',
});
